import React, { useState, useEffect } from 'react';
import PopularLocationListingItem from './PopularLocationListingItem';
import { geocodeLatLng } from '../util/GeoLocation';
import { toast } from 'react-toastify'
import {getQueryParamsFromPlace} from "../util/AddressUtils";

interface CityObj {
    id: string;
    city: string;
    rank: number;
    imageUrl: string;
    coordinates?: string;
}

interface SearchRedirectPopularLocationListingItemProps {
    cityObj: CityObj;
}

const SearchRedirectPopularLocationListingItem = (props: SearchRedirectPopularLocationListingItemProps) => {
    const [searchString, setSearchString] = useState("");

    useEffect(() => {
        if (props.cityObj?.coordinates) {
            const generateSearchString = async (coordinates: string): Promise<string> => {
                if (!coordinates || !coordinates.length) return Promise.resolve("");
                const coordinatesArr = coordinates.split(",");
                if (coordinatesArr.length < 2) return Promise.resolve("");

                const latStr = coordinatesArr[0].trim();
                const lngStr = coordinatesArr[1].trim();
                const lat = parseFloat(latStr);
                const lng = parseFloat(lngStr);
                if (!Number.isFinite(lat) || !Number.isFinite(lng)) return Promise.resolve("");

                return geocodeLatLng(lat, lng)
                    .then((location) => {
                        const locationItem = getQueryParamsFromPlace(location);
                        const searchParams = new URLSearchParams({
                            city: locationItem?.city || '',
                            state: locationItem?.state || '',
                            lat: latStr,
                            lng: lngStr,
                        });
                        const searchString = `?${searchParams.toString()}`;
                        setSearchString(searchString);
                        return searchString;
                    })
                    .catch((error) => {
                        toast.error(`SearchRedirectPopularLocationListingItem Error: ${error}`);
                        return "";
                    });
            };

            void generateSearchString(props.cityObj.coordinates);
        }
    }, [props.cityObj]);

    return (<PopularLocationListingItem cityObj={props.cityObj} linkTo={{ pathname: "/search", search: searchString }} />);
};

export default SearchRedirectPopularLocationListingItem;
